<template>
  <div>
    <h1>Register</h1>

    <b-form @submit.stop.prevent="submit">
      <b-form-group id="form-name-group" label="Name:" label-for="form-text-name">
        <b-input type="text" id="form-text-name" required placeholder="Eric Pode" v-model="name"></b-input>
      </b-form-group>

      <b-form-group id="form-email-group" label="Email addres:" label-for="form-text-email">
        <b-input
          type="email"
          id="form-text-email"
          required
          placeholder="email address"
          v-model="email"
        ></b-input>
      </b-form-group>

      <b-form-group id="form-password-1-group" label="Password:" label-for="form-text-password-1">
        <b-input
          type="password"
          id="form-text-password-1"
          required
          v-model="password1"
          :state="pwdmatch"
        ></b-input>
      </b-form-group>

      <b-form-group
        id="form-password-2-group"
        label="Confirm password:"
        label-for="form-text-password-2"
      >
        <b-input
          type="password"
          id="form-text-password-2"
          required
          v-model="password2"
          :state="pwdmatch"
        ></b-input>
        <b-form-invalid-feedback :state="pwdmatch">Passwords don't match</b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" variant="primary" :disabled="!okToSubmit">Register</b-button>
    </b-form>
    <b-alert :show="!!error" variant="warning">{{error}}</b-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import fb from "@/firebaseConfig";
export default {
  methods: {
    async submit() {
      fb.auth
        .createUserWithEmailAndPassword(this.email, this.password1)
        .then(cred => {
          fb.db
            .collection("users")
            .doc(cred.user.uid)
            .set({
              name: this.name
            });
        })
        .then(() => this.$router.replace({ name: "profile" }))
        .catch(err => {
          this.error = err.message;
        });
    }
  },
  data() {
    return {
      name: "",
      email: "",
      password1: "",
      password2: "",
      error: ""
    };
  },
  computed: {
    pwdmatch() {
      if (!this.password2.length) {
        return null;
      } else {
        return this.password1 == this.password2;
      }
    },
    okToSubmit() {
      return !!this.pwdmatch && this.email.length >= 1;
    },
    ...mapGetters({ user: "user/user" })
  },
  mounted() {
    if (this.user.loggedIn) {
      this.$router.replace({ name: "profile" });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>